import {
    faInfoCircle,
    faPlus,
    faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import UnForm from "../../../../../Components/Form";
import { useHistory, useParams } from "react-router-dom";
import {
    ITwillioBase,
    ITwillioCallToActionType,
} from "../../../../../Interfaces/HelpDesk/GestaoTemplate/GestaoTemplateInterace";
import { SendTemplateTwilioController } from "../../../../../Controllers/HelpDesk/GestaoTemplate/GestaoTemplateController";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import { ACESSOS } from "../../../../../Routes/Acessos";

interface ButtonState {
    id: number;
    type: string;
    buttonText: string;
    phoneNumberOrURL: string;
    variableCount: number;
}

interface URLParams {
    name?: string;
    contentType?: string;
}

const tooltipMessage =
    "Clique aqui para adicionar variáveis neste campo. Variáveis permitem personalizar mensagens inserindo conteúdo dinâmico como nome de cliente ou URL única.";

// type Call to action
export default function ContentType4() {
    const history = useHistory();

    const [buttons, setButtons] = useState<ButtonState[]>([
        {
            id: 0,
            type: "PHONE_NUMBER",
            buttonText: "",
            phoneNumberOrURL: "",
            variableCount: 0,
        },
    ]);

    const { name } = useParams<URLParams>();

    const bodyRef = useRef<HTMLTextAreaElement>(null);

    const [bodyContent, setBodyContent] = useState("");

    const [variableCountBody, setVariableCountBody] = useState(0);

    const [variables, setVariables] = useState<{ [key: string]: string }>({});

    const handleBodyContentChangeBody = (
        e: React.ChangeEvent<HTMLTextAreaElement>
    ) => {
        setBodyContent(e.target.value);
    };

    const handleInputChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
        index: number,
        field: "type" | "buttonText" | "phoneNumberOrURL"
    ) => {
        const updatedButtons = [...buttons];
        updatedButtons[index][field] = e.target.value;
        setButtons(updatedButtons);
    };

    const insertVariable = (
        index: number,
        field: "buttonText" | "phoneNumberOrURL" | "body"
    ) => {
        const newVariable = `{{${variableCountBody + 1}}}`;

        if (field === "body") {
            const cursorPos = bodyRef.current?.selectionStart || 0;
            const textBeforeCursor = bodyContent.substring(0, cursorPos);
            const textAfterCursor = bodyContent.substring(
                cursorPos,
                bodyContent.length
            );
            setBodyContent(
                `${textBeforeCursor}${newVariable}${textAfterCursor}`
            );
            setVariableCountBody(variableCountBody + 1);
            setVariables({
                ...variables,
                [newVariable]: "",
            });
        } else if (field === "buttonText" || field === "phoneNumberOrURL") {
            const updatedButtons = [...buttons];
            const currentText = updatedButtons[index][field];
            const cursorPos = currentText.length;
            const textBeforeCursor = currentText.substring(0, cursorPos);
            const textAfterCursor = currentText.substring(
                cursorPos,
                currentText.length
            );

            updatedButtons[index][
                field
            ] = `${textBeforeCursor}${newVariable}${textAfterCursor}`;
            updatedButtons[index].variableCount += 1;

            setButtons(updatedButtons);
            setVariableCountBody(variableCountBody + 1);
            setVariables({
                ...variables,
                [newVariable]: "",
            });
        }
    };

    const handleVariableChange = (
        variable: string,
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        setVariables({
            ...variables,
            [variable]: e.target.value,
        });

        let updatedBodyContent = bodyContent;
        let updatedButtons = [...buttons];

        updatedBodyContent = updatedBodyContent.replace(
            variable,
            e.target.value
        );
        setBodyContent(updatedBodyContent);

        updatedButtons = updatedButtons.map((button) => {
            return {
                ...button,
                buttonText: button.buttonText.replace(variable, e.target.value),
                phoneNumberOrURL: button.phoneNumberOrURL.replace(
                    variable,
                    e.target.value
                ),
            };
        });
        setButtons(updatedButtons);
    };

    const removeVariable = (variable: string) => {
        const { [variable]: removed, ...remainingVariables } = variables;
        setVariables(remainingVariables);

        setBodyContent(bodyContent.replace(variable, ""));

        const updatedButtons = buttons.map((button) => {
            return {
                ...button,
                buttonText: button.buttonText.replace(variable, ""),
                phoneNumberOrURL: button.phoneNumberOrURL.replace(variable, ""),
            };
        });
        setButtons(updatedButtons);
    };

    const addButton = () => {
        if (buttons.length >= 2) return;

        const newButtonType =
            buttons.length === 1 && buttons[0].type === "PHONE_NUMBER"
                ? "URL"
                : "PHONE_NUMBER";

        setButtons([
            ...buttons,
            {
                id: buttons.length,
                type: newButtonType,
                buttonText: "",
                phoneNumberOrURL: "",
                variableCount: 0,
            },
        ]);
    };

    const removeButton = (index: number) => {
        const updatedButtons = buttons.filter((_, i) => i !== index);
        setButtons(updatedButtons);

        const removedButtonVariables = buttons[index].variableCount;
        const removedVariables = Object.keys(variables).filter((variable) =>
            variable.includes(`{{${removedButtonVariables}}}`)
        );
        const { [Number(removedVariables)]: removed, ...remainingVariables } =
            variables;
        setVariables(remainingVariables);
    };

    const { execute: SendTemplateTwilio, loading: SendTemplateTwilioLoading } =
        useAsyncCallback(SendTemplateTwilioController);

    function handleCallToAction(
        formData: ITwillioBase<ITwillioCallToActionType>
    ) {
        const requestBody = {
            ...formData,
            friendly_name: name ?? "",
            language: "pt_BR",
            variables: variables,
        };

        const jsonString = JSON.stringify(requestBody);

        SendTemplateTwilio(jsonString, "CALL_TO_ACTION").then(() => {
            setBodyContent("");
            setVariables({});
            history.push(ACESSOS.HELPDESK.TELAS.GESTAO_TEMPLATES.DS_PATH);
        });
    }

    return (
        <UnForm handleSubmit={handleCallToAction}>
            <div>
                <label>Body</label>
                <UnForm.Textarea
                    name="types.twilio/call-to-action.body"
                    className="form form-control"
                    placeholder="Digite o conteúdo do body aqui"
                    value={bodyContent}
                    onChange={handleBodyContentChangeBody}
                    rows={4}
                    required
                />

                <div className="d-flex justify-content-end align-items-center mt-2">
                    <button
                        className="btn"
                        type="button"
                        onClick={(e) => insertVariable(0, "body")}
                    >
                        + Adicionar variável
                    </button>
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip id="tooltip-top">{tooltipMessage}</Tooltip>
                        }
                    >
                        <FontAwesomeIcon icon={faInfoCircle} />
                    </OverlayTrigger>
                </div>
            </div>
            {buttons.map((button, index) => (
                <div className="card p-3 mb-3" key={button.id}>
                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <h3>Botão</h3>
                        </div>
                        <div>
                            {buttons.length > 1 && (
                                <div className="d-flex justify-content-end align-items-center mt-2">
                                    <button
                                        className="btn btn-outline-danger"
                                        type="button"
                                        onClick={() => removeButton(index)}
                                    >
                                        <FontAwesomeIcon icon={faTrash} />{" "}
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="p-2">
                        <div>
                            <label>Tipo de ação</label>
                            <UnForm.Select
                                name={`types.twilio/call-to-action.actions.[${index}].type`}
                                className="form form-control"
                                value={button.type}
                                onChange={(e) =>
                                    handleInputChange(e, index, "type")
                                }
                                required
                            >
                                <option value="PHONE_NUMBER">
                                    Phone number
                                </option>
                                <option value="URL">Visit web</option>
                            </UnForm.Select>
                        </div>
                        <div>
                            <label>Texto do Botão</label>
                            <input
                                className="form form-control"
                                placeholder="Digite o conteúdo do botão aqui"
                                value={button.buttonText}
                                onChange={(e) =>
                                    handleInputChange(e, index, "buttonText")
                                }
                            />
                            <div className="d-flex justify-content-between px-1">
                                <div className="text-muted">
                                    Suporta imagens, áudio, documentos e vídeo.
                                </div>
                            </div>
                            <div className="d-flex justify-content-end align-items-center mt-2">
                                <button
                                    className="btn"
                                    type="button"
                                    onClick={() =>
                                        insertVariable(index, "buttonText")
                                    }
                                >
                                    + Adicionar variável
                                </button>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={
                                        <Tooltip id="tooltip-top">
                                            {tooltipMessage}
                                        </Tooltip>
                                    }
                                >
                                    <FontAwesomeIcon icon={faInfoCircle} />
                                </OverlayTrigger>
                            </div>
                        </div>
                        <div>
                            <label>
                                {button.type === "PHONE_NUMBER"
                                    ? "Phone number"
                                    : "Website URL"}
                            </label>
                            <UnForm.Input
                                name={`${
                                    button.type === "PHONE_NUMBER"
                                        ? `types.twilio/call-to-action.actions.[${index}].PHONE_NUMBER`
                                        : `types.twilio/call-to-action.actions.[${index}].URL`
                                }`}
                                className="form form-control"
                                placeholder={`Digite ${
                                    button.type === "PHONE_NUMBER"
                                        ? "+15551234567"
                                        : "https://www"
                                }`}
                                value={button.phoneNumberOrURL}
                                onChange={(e) =>
                                    handleInputChange(
                                        e,
                                        index,
                                        "phoneNumberOrURL"
                                    )
                                }
                                required
                            />
                            <div className="d-flex justify-content-between px-1">
                                <div className="text-muted">
                                    {button.type === "PHONE_NUMBER" ? (
                                        <>
                                            Um número válido no formato{" "}
                                            <a
                                                href="https://www.twilio.com/docs/glossary/what-e164?_gl=1*15wxmsl*_gcl_au*MTc2NDE5MDMyNy4xNzE5NTcyOTg2*_ga*ODI4MTg4NDA5LjE3MTk1NzMwMTg.*_ga_RRP8K4M4F3*MTcxOTU5MjU3MS40LjEuMTcxOTU5NDc4Ni4wLjAuMA.."
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                E.164 format
                                            </a>{" "}
                                            é necessário. Por favor, inclua um
                                            prefixo +Código do País.
                                            Identificador único. Não visível
                                            para o destinatário.
                                        </>
                                    ) : (
                                        "Apenas uma variável pode ser adicionada ao final de um URL. Identificador único. Não visível para o destinatário."
                                    )}
                                </div>
                            </div>
                            <div className="d-flex justify-content-end align-items-center mt-2">
                                <button
                                    className="btn"
                                    type="button"
                                    onClick={() =>
                                        insertVariable(
                                            index,
                                            "phoneNumberOrURL"
                                        )
                                    }
                                >
                                    + Adicionar variável
                                </button>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={
                                        <Tooltip id="tooltip-top">
                                            {tooltipMessage}
                                        </Tooltip>
                                    }
                                >
                                    <FontAwesomeIcon icon={faInfoCircle} />
                                </OverlayTrigger>
                            </div>
                        </div>
                    </div>
                </div>
            ))}

            <div className="py-2">
                <button
                    className="btn btn-outline-primary"
                    type="button"
                    onClick={addButton}
                    disabled={buttons.length >= 2}
                >
                    Adicionar botão
                </button>
            </div>

            <div className="mt-3">
                {Object.keys(variables).map((variable, index) => (
                    <div key={index} className="mb-2">
                        <label>{variable}</label>
                        <div className="input-group">
                            <input
                                type="text"
                                className="form-control"
                                value={variables[variable]}
                                onChange={(e) =>
                                    handleVariableChange(variable, e)
                                }
                                required
                            />
                            <div className="input-group-append">
                                <button
                                    className="btn btn-outline-danger"
                                    type="button"
                                    onClick={() => removeVariable(variable)}
                                >
                                    <FontAwesomeIcon icon={faTrash} />
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <hr className="my-5 " />

            <div className="d-flex justify-content-start">
                <div>
                    <UnForm.SubmitButton
                        icon={faPlus}
                        disabled={SendTemplateTwilioLoading}
                        loading={SendTemplateTwilioLoading}
                        loadingSize="sm"
                        wrapperClassName="m-0"
                        color="success"
                    >
                        Criar
                    </UnForm.SubmitButton>
                </div>
                <div>
                    <button
                        className="btn btn-secondary ml-2"
                        type="button"
                        onClick={() => {
                            history.push(
                                ACESSOS.HELPDESK.TELAS.GESTAO_TEMPLATES_TWILIO
                                    .DS_PATH
                            );
                        }}
                    >
                        Cancelar
                    </button>
                </div>
            </div>
        </UnForm>
    );
}
